import { WsReactBaseService } from '@thewhite/react-base-components';
import { BaseActions } from '@thewhite/react-global-module/lib/actions';
import { AxiosRequestConfig } from 'axios';
import { forOwn } from 'lodash';
import { api } from '../../../config/api';
import { globalConfig } from '../../../config/globalConfig';
import { OAuthParams } from '../interfaces/OAuthParams';
import { TokenParams } from '../interfaces/TokenParams';
import { AuthService } from '../services/authServices';

export class AuthActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/auth-service/`;

    static API_RESOURCE(url: string, method: string = WsReactBaseService.GET_METHOD, params: any = {}, config: any = {}, withoutToast: boolean = false): Promise<any> {
        if (method === WsReactBaseService.GET_METHOD) {
            let configForGet: AxiosRequestConfig = WsReactBaseService.parseParamsAndConfig(method, params, config).config;
            configForGet.params = params;
            return WsReactBaseService.doPromise(api.get(`${this.DEFAULT_URL}${url}`, configForGet), withoutToast);
        }
        return WsReactBaseService.doPromise(api.post(`${this.DEFAULT_URL}${url}`, WsReactBaseService.parseParamsAndConfig(method, params, config).params, WsReactBaseService.parseParamsAndConfig(method, params, config).config), withoutToast);
    }

    /**
     * Получаем информацию о пользователе
     */
    static whoami() {
        return AuthActions.API_RESOURCE(
            'external/users/whoami',
            WsReactBaseService.GET_METHOD,
            {},
            {},
            true,
        )
            .then((res) => {
                if (res) AuthService.setUserInfo(res);
                return res;
            });
    }

    /**
     * Авторизация пользователя по паре логин / пароль
     * @param {String} login
     * @param {String} password
     * @param {Boolean} refresh
     * @param {String | null} captcha
     */
    static token(
        login: string,
        password: string,
        refresh: boolean = false,
        captcha: string | null = null,
    ) {
        const _params: TokenParams = {
            ...this.getOAuthParameters(captcha),
            grant_type: refresh ? 'refresh_token' : 'password',
        };
        if (!refresh) {
            _params.username = login;
            _params.password = password;
        } else {
            _params.refresh_token = AuthService.getUserInfo().refresh_token;
        }
        const config = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
        };

        const str: string[] = [];
        forOwn(_params, (value, field) => {
            if (!value) return;
            str.push(`${encodeURIComponent(field)}=${encodeURIComponent(value)}`);
        });

        return AuthActions.API_RESOURCE(
            refresh ? 'refresh-token' : 'oauth/token',
            WsReactBaseService.POST_METHOD,
            str.join('&'),
            config,
            true,
        )
            .then((res) => {
                if (res) AuthService.setUserInfo(res);
                return res;
            });
    }

    /**
     * Формирование параметров авторизации
     * @param {String} captcha
     */
    static getOAuthParameters(captcha: string | null = null): OAuthParams {
        const _params: OAuthParams = { scope: 'web' };
        if (captcha) {
            _params['g-recaptcha-response'] = captcha;
        }
        return _params;
    }

    /**
     * Действие выхода из системы
     */
    static logOut() {
        const config = {
            headers: {
                Authorization: `Bearer ${AuthService.getUserInfo() ? AuthService.getUserInfo().access_token : ''}`,
            },
        };

        return AuthActions.API_RESOURCE(
            'auth/logout',
            WsReactBaseService.GET_METHOD,
            {},
            config,
            true,
        );
    }
}
